import { useAtom } from 'jotai';
import { maskAtom } from './Data/Atoms';
import { motion, AnimatePresence } from 'framer-motion';

export const PageMask = () => {
    const [maskOptions] = useAtom(maskAtom);

    return (
        <AnimatePresence>
            {maskOptions?.showMask && (
                <motion.div 
                    className="page-mask"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.15 }}
                >
                    <div className="mask-dialog">
                        <div className="mask-loader-container">
                            {[0, 1, 2].map((index) => (
                                <motion.div
                                    key={index}
                                    className="mask-loader"
                                    animate={{
                                        scale: [1, 1.2, 1],
                                        opacity: [1, 0.5, 1]
                                    }}
                                    transition={{
                                        duration: 1,
                                        repeat: Infinity,
                                        delay: index * 0.2,
                                        ease: "easeInOut"
                                    }}
                                />
                            ))}
                        </div>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};

